import MesAidesLayout from "@/components/mes-aides-layout.vue"
import Home from "@/views/home.vue"
import Simulation from "@/views/simulation.vue"

export default {
  Home,
  routes: [],
  name: "mes-aides",
  Layout: MesAidesLayout,
  Simulation,
}
